export default "__VITE_ASSET__DN0QGrzp__"